import { render, staticRenderFns } from "./ministers.vue?vue&type=template&id=5d5e58c7&scoped=true"
import script from "./ministers.vue?vue&type=script&lang=js"
export * from "./ministers.vue?vue&type=script&lang=js"
import style0 from "./ministers.vue?vue&type=style&index=0&id=5d5e58c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5e58c7",
  null
  
)

export default component.exports